import React from "react";
import sterlingImg from "../../../src/assets/images/sterling_ta.png";
import { useSelector } from "react-redux";

const TripAdvisor = () => {
  const { hotelData } = useSelector((state) => state.hotelInfo);
  console.log("id", hotelData?.id);

  return (
    <div
      id="TA_certificateOfExcellence157"
      className="TA_certificateOfExcellence"
    >
      <img
        src={
          hotelData?.id === 4606
            ? sterlingImg
            : "https://static.tacdn.com/img2/travelers_choice/widgets/tchotel_2025_L.png"
        }
        // src="https://static.tacdn.com/img2/travelers_choice/widgets/tchotel_2025_L.png"
        // src={sterlingImg}
        alt="TripAdvisor"
        className="widCOEImg"
        id="CDSWIDCOELOGO"
        width={100}
      />
    </div>
  );
};

export default TripAdvisor;
